/** Cookiebanner voor analytics-toestemming (productie). */
import { Alert, Button, Stack } from '@mui/material';
import { useT } from '@/i18n/useT';
import { useCookieConsentBanner } from '@/features/consent/hooks/useCookieConsentBanner';

const CookieConsentBanner = () => {
  const t = useT();
  const { visible, onAccept, onReject } = useCookieConsentBanner();

  if (!visible) {
    return null;
  }

  return (
    <Alert
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-labelledby="cookie-consent-message"
      severity="info"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.snackbar,
        borderRadius: 0,
        m: 0,
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ sm: 'center' }}
        justifyContent="space-between"
      >
        <span id="cookie-consent-message">
          {t(
            'consent.analytics.message',
            'We gebruiken analytics-cookies om te begrijpen hoe Todoes wordt gebruikt. Je kunt accepteren of weigeren.',
          )}
        </span>
        <Stack direction="row" spacing={1} flexShrink={0}>
          <Button
            variant="outlined"
            color="inherit"
            size="small"
            onClick={onReject}
          >
            {t('consent.analytics.reject', 'Weigeren')}
          </Button>
          <Button variant="contained" color="primary" size="small" onClick={onAccept}>
            {t('consent.analytics.accept', 'Accepteren')}
          </Button>
        </Stack>
      </Stack>
    </Alert>
  );
};

export default CookieConsentBanner;
